var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31622 3.3714L6.85676 0.915184C7.36161 0.642677 7.9263 0.5 8.5 0.5C9.0737 0.5 9.63839 0.642677 10.1432 0.915184L14.6838 3.3714C15.2317 3.66714 15.6896 4.10525 16.0092 4.63954C16.3289 5.17382 16.4985 5.78447 16.5 6.40708V12.9973C16.5 13.9149 16.1355 14.7948 15.4867 15.4436C14.838 16.0923 13.958 16.4568 13.0405 16.4568H3.95946C3.04195 16.4568 2.16203 16.0923 1.51325 15.4436C0.864478 14.7948 0.5 13.9149 0.5 12.9973V6.40708C0.501549 5.78447 0.671093 5.17382 0.99075 4.63954C1.31041 4.10525 1.76833 3.66714 2.31622 3.3714Z",
    stroke: "#2E2C27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.638428 5.44708L6.77032 8.99303C7.29622 9.29666 7.89279 9.45651 8.50005 9.45651C9.10731 9.45651 9.70387 9.29666 10.2298 8.99303L16.4049 5.53357",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail1);
export default __webpack_public_path__ + "static/media/email-1.9fb609f4632efe8317eb740561644f97.svg";
export { ForwardRef as ReactComponent };